import React from 'react';
import { string, object, func, bool, oneOf, oneOfType, node } from 'prop-types';
import setClass from '../../common/set-class';
const Radio = ({ isDisabled, disabled, checked, label, labelPosition, name, value, id, onChange, className, style, }) => {
    const _label = label && React.createElement("span", { className: "b-radio-text" }, label);
    return (React.createElement("label", { style: style, className: setClass([
            (disabled || isDisabled) && 'b-not-allowed',
            'b-radio',
            className,
        ]), htmlFor: id || null },
        React.createElement("input", { type: "radio", id: id || '', name: name, className: "b-radio-input", value: value, onChange: (e) => {
                if (!(disabled || isDisabled) && onChange) {
                    onChange(e);
                }
            }, disabled: isDisabled || disabled, checked: checked }),
        labelPosition === 'left' && _label,
        React.createElement("span", { className: "b-radio-circle" }),
        labelPosition === 'right' && _label));
};
Radio.propTypes = {
    className: string,
    style: object,
    name: string,
    onChange: func,
    isDisabled: bool,
    disabled: bool,
    checked: bool,
    label: oneOfType([string, node]),
    value: string,
    id: string,
    labelPosition: oneOf(['left', 'right']),
};
Radio.defaultProps = {
    className: '',
    style: {},
    name: '',
    onChange: () => { },
    isDisabled: false,
    disabled: false,
    label: '',
    value: '',
    id: '',
    labelPosition: 'right',
    checked: false,
};
export default Radio;
